<template>
    <div class="welcome-container">
        <p class="title">{{ titleText }}</p>
        <div class="email-input-wrapper">
            <label for="email-input">Email *</label>
            <input
                v-model="$v.userData.welcome.email.$model"
                v-autofocus
                @keydown="$v.userData.welcome.email.$touch"
                @keyup.enter="$emit('cta-clicked', actions.continue)"
                class="email-input"
                name="email-input"
                type="email"
                placeholder="Enter your email to get started..."
            />
            <p
                v-if="$v.userData.welcome.email.$dirty && !$v.userData.welcome.email.required"
                class="error-msg"
            >
                Please enter your email address.
            </p>
            <p
                v-else-if="
                    $v.userData.welcome.email.$dirty && !$v.userData.welcome.email.email
                "
                class="error-msg"
            >
                Please enter a valid email address.
            </p>
        </div>
        <button
            :disabled="$v.$dirty && $v.$invalid"
            @click="() => $emit('cta-clicked', actions.continue)"
            class="continue-btn"
        >
            Continue
        </button>
        <div class="social-auth">
            <p class="label">Or continue with...</p>
            <button
                v-for="social in socials"
                :key="social.name"
                :class="`${social.name}-auth`"
                @click="
                    () =>
                        redirectSocial(social, redirectStorageData, () =>
                            $emit('update:social', true)
                        )
                "
            >
                <img :src="social.icon" :alt="`${social.name}-auth`" />
            </button>
        </div>
    </div>
</template>
<script>
    import { required, email } from 'vuelidate/lib/validators'
    import { useSocialAuth } from '@/composables/features/socials/useSocialAuth'

    export default {
        name: 'Welcome',
        props: {
            redirectStorageData: {
                type: Object,
                required: true
            },
            userData: {
                type: Object,
                required: true
            },
            validation: {
                type: Object,
                required: false
            },
            social: {
                type: Boolean,
                required: true
            },
            actions: {
                type: Object,
                required: true
            },
            titleText: {
                type: String,
                required: false,
                default: 'Log in or register to make an offer'
            }
        },
        emits: ['cta-clicked', 'update:social', 'update:validation'],
        validations: {
            userData: {
                welcome: {
                    email: { required, email }
                }
            }
        },
        setup() {
            const { socials, redirectSocial } = useSocialAuth()
            return {
                socials,
                redirectSocial
            }
        },
        watch: {
            $v: {
                handler: function (validation) {
                    this.$emit('update:validation', validation)
                },
                immediate: true
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    .welcome-container {
        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }
        button:disabled {
            opacity: 0.5;
        }

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        width: 100%;
        gap: 40px;

        .title {
            color: #dedede;
            @include base-font-24;
            font-weight: 600;
            line-height: 28px;
        }
        .email-input-wrapper {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            width: 100%;
            gap: 6px;

            label {
                color: #acacac;
                font-family: Instrument Sans;
                font-size: 12px;
                font-style: normal;
                font-weight: 650;
                line-height: 135%;
                letter-spacing: 0.12px;
            }
            .email-input {
                padding: 12px 16px 16px 16px;
                border-radius: 12px;
                border: 1px solid #8b8b8b;
                background: #262626;
                overflow: hidden;
                color: #dedede;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-family: Instrument Sans;
                font-size: 16px;
                font-style: normal;
                font-weight: 550;
                line-height: 125%;
                align-self: stretch;
                width: 99%;
                margin-left: auto;
                margin-right: auto;
            }
            .error-msg {
                color: #ed3c0d;
                font-family: Instrument Sans;
                font-size: 10px;
                font-style: normal;
                font-weight: 600;
                line-height: 130%;
                letter-spacing: 0.14px;
                height: 40px;
            }
        }
        .continue-btn {
            padding: 11px 30px 12px 30px;
            border-radius: 100px;
            background: #cdeb09;
            align-self: stretch;
            color: #121212;
            font-family: Instrument Sans;
            font-size: 18px;
            font-style: normal;
            font-weight: 550;
            line-height: 120%;
        }
        .social-auth {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: 16px;

            .label {
                color: #8b8b8b;
                text-align: center;
                @include base-font-12;
                font-weight: 400;
            }
            .google-auth {
                background: none;
            }
        }
    }
</style>
